<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'default',
})
</script>
<template>
    <div v-if="data" >
      <contenttitle :data="data" ></contenttitle>
      <a-row :gutter="[30,30]">
        <a-col class="content-box" :sm="getCol.sm(data.col)" :md="getCol.md(data.col)"     :lg="getCol.lg(data.col)"  v-for="(item,i) in data.child" :key="i">
            <a :href="item.url">
              <img :src="addip(item.pic)" style="width: 100%;height:auto;min-height: 240px;" />
            </a>
            <h4 >{{ item.name }}</h4>
            <h5 v-if="item.sub">{{ item.name }}</h5>
        </a-col>
      </a-row>
    </div>
</template>
<script setup lang="ts" name="default">
import {defineComponent,defineProps } from 'vue';
import {addip,getCol} from '@/utils/util'
defineProps({
  data:Object
})
</script>
